import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { Modal } from 'antd';
import Translate from 'react-translate-component';
import moment from 'moment';
import * as yup from 'yup';

import DatePicker from 'components/common/form/DatePicker';
import { DATE_FORMATS } from 'constants/dateFormats';
import { TASK_PRIORITIES_RADIO_ICONS } from 'constants/calendar';
import Input from 'components/common/form/Input';
import CustomSwitch from 'components/common/form/Switch';
import RadioIcons from 'components/common/form/RadioIcons';
import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import ItemModalFooter from 'components/common/ItemModalFooter';
import withFormWrapper from 'components/hocs/withFormWrapper';

const validateDateTo = (to, { date }) => {
    const dateTo = moment(to, DATE_FORMATS.format);
    const dateFrom = date && moment(date.from, DATE_FORMATS.format);
    return dateTo.isBefore(dateFrom) && 'dateIsNotBefore';
};

const validationSchema = yup.object().shape({
    description: yup.string().maxLength(127).required(),
    date: yup.object().shape({
        from: yup.string().required(),
        to: yup.string().required()
    })
});

@withAutoFocusForm
@withFormWrapper({
	mapPropsToValues: props => props.initialValues,
	validationSchema
})
export default class TaskModal extends Component {
    static propTypes = {
        modal: PropTypes.object.isRequired,
        titleTranslate: PropTypes.string.isRequired,
        meta: PropTypes.object,
        handleSubmit: PropTypes.func.isRequired,
    }

    renderFooter() {
        const { meta, handleSubmit } = this.props;

        return (
            <ItemModalFooter meta={meta} handleSubmit={handleSubmit} />
        );
    }

    render() {
        const { modal, titleTranslate } = this.props;

        return (
            <Modal {...modal} title={<Translate content={titleTranslate} />} footer={this.renderFooter()}>
                <form>
                    <Field  name='description'
                            component={Input}
                            label={{ content: 'calendar.description', required: true }}/>
                    <Field  name='date.from'
                            component={DatePicker}
                            label={{ content: 'calendar.date_from', required: true }} />
                    <Field  name='date.to'
                            component={DatePicker}
                            validate={validateDateTo}
                            label={{ content: 'calendar.date_to', required: true }} />
                    <Field  name='priority'
                            component={RadioIcons}
                            useBadge={true}
                            className='calendar-modal-badge'
                            options={TASK_PRIORITIES_RADIO_ICONS}
                            label={{ content: 'calendar.create.priority' }} />
                    <Field  name='done'
                            component={CustomSwitch}
                            label={{ content: 'calendar.create.done' }} />
                </form>
            </Modal>
        );
    }
}
